import React from "react";
import { useNavigate } from "react-router-dom";
import { useEntitlements } from "../entitlements/EntitlementContext";
import { PWG_SPORTS_PRODUCT } from "../config/publicProductCatalog";
import "./Billing.css";

export default function Pricing() {
  const navigate = useNavigate();
  const entitlement = useEntitlements();
  const product = PWG_SPORTS_PRODUCT;
  const active = entitlement.applications?.PWG?.enabled === true;

  const purchase = async (term) => {
    try {
      await entitlement.checkout(product.productKey, term);
    } catch (error) {
      if (["change_term", "already_covered", "manage_subscription"].includes(error?.action)) {
        alert("Your existing PWG Sports subscription is already active. Use Manage Billing to make changes.");
        return;
      }
      alert(error?.message || "Unable to start checkout.");
    }
  };

  const periodEnd = entitlement.currentPeriodEnd
    ? new Date(Number(entitlement.currentPeriodEnd) * 1000).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })
    : null;

  return (
    <main className="billing-shell billing-pricing-page">
      <div className="billing-orb billing-orb-one" />
      <div className="billing-orb billing-orb-two" />
      <div className="billing-container">
        <button className="billing-back" onClick={() => navigate("/")}><span aria-hidden="true">←</span> Back to App</button>
        <header className="billing-hero">
          <div className="billing-brand-kicker">PLAYSWITHGURU</div>
          <h1>PWG Sports</h1>
          <p>Sports prop intelligence with full analytical access and Guru Plays. Choose the billing term that works for you.</p>
        </header>

        <section className="billing-plan-grid" aria-label="PWG Sports subscription plans">
          <article className="billing-plan-card billing-plan-card--featured">
            <div className="billing-best-value">PWG SPORTS</div>
            <div className="billing-plan-top">
              <div className="billing-plan-eyebrow">SPORTS INTELLIGENCE</div>
              <div className="billing-plan-title-row"><h2>{product.publicName}</h2>{active && <span className="billing-status-pill">ACTIVE</span>}</div>
              <p>One paid product. No trial and no free sports-intelligence tier.</p>
            </div>
            <div className="billing-price-block">
              <span className="billing-term-label">Monthly</span>
              <div className="billing-price-row"><strong>{product.offers.monthly.displayAmount}</strong><span>/ month</span></div>
              <button className="billing-cta" onClick={() => purchase(product.offers.monthly.term)} disabled={entitlement.loading || entitlement.isAdmin || active}>
                {active ? "Current Product" : "Choose Monthly"}
              </button>
            </div>
            <div className="billing-quarterly-block">
              <div className="billing-quarterly-head"><span>3 Months</span><span className="billing-savings">Save {product.threeMonthSavings.displayAmount}</span></div>
              <div className="billing-quarterly-price"><strong>{product.offers.threeMonth.displayAmount}</strong><span>/ 3 months</span></div>
              <p>Approximately {product.threeMonthSavings.effectiveMonthly} per month.</p>
              <button className="billing-cta billing-cta--secondary" onClick={() => purchase(product.offers.threeMonth.term)} disabled={entitlement.loading || entitlement.isAdmin || active}>
                {active ? "Already Active" : "Choose 3 Months"}
              </button>
            </div>
          </article>
        </section>

        {(entitlement.isStripePremium || periodEnd) && (
          <section className="billing-membership-panel">
            <div><div className="billing-membership-kicker">YOUR PWG MEMBERSHIP</div><h3>PWG Sports</h3>
              {periodEnd && <p className="billing-membership-date">{entitlement.cancelAtPeriodEnd ? "Your current access remains active through " : "Current billing period ends "}<strong>{periodEnd}</strong>.</p>}
            </div>
            {entitlement.isStripePremium && <button className="billing-manage-button" onClick={() => entitlement.manageBilling()}>Manage Billing</button>}
          </section>
        )}
        {entitlement.error && <div className="billing-inline-error" role="alert">{entitlement.error}</div>}
        <footer className="billing-footer-note">Secure checkout powered by Stripe · Your subscription redirect is never used as proof of access.</footer>
      </div>
    </main>
  );
}
